import { useEffect, useState } from "react";

import { Bar, Doughnut } from "react-chartjs-2";

import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";
import { Icon } from "@iconify/react";

import { MenuItem, Select } from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";
import "./ACDMonitoring.css";
import formatSecondsToDuration from "../Helper/formatSecondsToDuration";
import { ReactComponent as IVRMonitoringIcon } from "../Images/IVRMonitoringIcon.svg";
import { ReactComponent as LegendACW } from "../Images/LegendACW.svg";
import { ReactComponent as LegendAUX } from "../Images/LegendAUX.svg";
import { getACDMonitoring } from "../Store/Actions/MonitoringAction";
import { SeverityPill } from "../Dashboard/SeverityPill";

const ACDMonitoring = ({ ACDDeviceID }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [showIVRDetail, setshowIVRDetail] = useState(false);
  const [showCallsWaiting, setshowCallsWaiting] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = () => {
      getACDMonitoring(ACDDeviceID === -1 ? null : ACDDeviceID)
        .then((response) => {
          if (response.status) {
            console.log("ACD monitor data: ", response.data);
            setData(response.data);
            setStatusCount(countAgentStatus(response.data.acdagentDetail));
          } else {
            console.log("error", response.error);
          }

          setIsLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
        });
    };

    // Fetch data on first render
    fetchData();

    // Fetch data every 10 seconds
    const interval = setInterval(() => {
      fetchData();
    }, 10000);

    return () => clearInterval(interval);
  }, [ACDDeviceID]);

  // const dummyACDAgents = [
  //   {
  //     id: 1,
  //     agent: "cole",
  //     status: "ready",
  //     ext: 258,
  //     aht: 120000,
  //     offered: 1,
  //     connected: 12,
  //     abandoned: 2,
  //     ghost: 928,
  //   },

  //   {
  //     id: 2,
  //     agent: "kdot",
  //     status: "busy",
  //     ext: 258,
  //     aht: 120000,
  //     offered: 2,
  //     connected: 12,
  //     abandoned: 2,
  //     ghost: 928,
  //   },

  //   {
  //     id: 3,
  //     agent: "drizzy",
  //     status: "ready",
  //     ext: 258,
  //     aht: 120000,
  //     offered: 2,
  //     connected: 12,
  //     abandoned: 2,
  //     ghost: 928,
  //   },

  //   {
  //     id: 4,
  //     agent: "21",
  //     status: "ready",
  //     ext: 258,
  //     aht: 120000,
  //     offered: 2,
  //     connected: 12,
  //     abandoned: 2,
  //     ghost: 928,
  //   },

  //   {
  //     id: 5,
  //     agent: "jid",
  //     status: "not bound",
  //     ext: 258,
  //     aht: 120000,
  //     offered: 1,
  //     connected: 12,
  //     abandoned: 2,
  //     ghost: 928,
  //   },

  //   {
  //     id: 6,
  //     agent: "keem",
  //     status: "busy",
  //     ext: 258,
  //     aht: 120000,
  //     offered: 1,
  //     connected: 12,
  //     abandoned: 2,
  //     ghost: 928,
  //   },
  // ];

  const countAgentStatus = (data) => {
    const filteredAgents = data
      ? data.filter((agent) => agent.CurrentState !== "LOGGEDOFF")
      : [];

    const countStatus = (status) =>
      filteredAgents.reduce(
        (counter, obj) => (obj.CurrentState === status ? ++counter : counter),
        0
      );

    return {
      ready: countStatus("READY"),
      busy: countStatus("BUSY"),
      acw: countStatus("ACW"),
      aux: countStatus("AUX"),
      notBound: countStatus("NOT BOUND"),
    };
  };

  const [statusCount, setStatusCount] = useState({});

  const columnsIVR = [
    {
      align: "center",
      flex: 1,
      headerAlign: "center",
      headerName: "No",
      maxWidth: 50,
      renderCell: (params) => params.api.getRowIndex(params.id) + 1,
    },

    {
      field: "CallerNo",
      flex: 1,
      headerName: "Phone No",
      minWidth: 150,
    },

    {
      field: "callTime",
      flex: 1,
      headerName: "Call Time",
      minWidth: 165,
      renderCell: (params) =>
        moment.utc(params.row.CallTime).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      field: "CallState",
      flex: 1,
      headerName: "Status",
      minWidth: 135,
    },

    {
      field: "menu",
      flex: 1,
      headerName: "Menu",
      minWidth: 120,
    },

    {
      field: "TotalDuration",
      flex: 1,
      headerName: "Duration",
      renderCell: (params) => formatSecondsToDuration(params.row.TotalDuration),
    },

    {
      field: "IVRName",
      flex: 1,
      headerName: "IVR Name",
    },
  ];

  const columnsCallsWaiting = [
    {
      align: "center",
      field: "ID",
      flex: 1,
      headerAlign: "center",
      headerName: "No",
      maxWidth: 50,
      renderCell: (params) => params.api.getRowIndex(params.row.ID) + 1,
    },

    {
      field: "CallerNo",
      flex: 1,
      headerName: "Phone No",
    },

    {
      field: "WaitDuration",
      flex: 1,
      headerName: "Wait Duration",
      // renderCell: (params) => moment.utc(params.row.duration).format("mm:ss"),
    },

    {
      field: "AgentName",
      flex: 1,
      headerName: "Agent",
    },
  ];

  const columnsACDAgents = [
    {
      field: "AgentName",
      flex: 1,
      headerName: "Agent Name",
    },

    {
      field: "CurrentState",
      flex: 1,
      headerName: "Status",
      minWidth: 135,

      renderCell: (params) => (
        <SeverityPill color={params.row.CurrentState.toLowerCase()}>
          {params.row.CurrentState}
        </SeverityPill>
      ),
    },

    {
      field: "Ext",
      flex: 1,
      headerName: "Ext",
    },

    {
      field: "AHT",
      flex: 1,
      headerName: "AHT",
      renderCell: (params) => formatSecondsToDuration(params.row.AHT),
    },

    {
      field: "CallsOffered",
      flex: 1,
      headerName: "Calls Offered",
    },

    {
      field: "CallsAnswered",
      flex: 1,
      headerName: "Calls Answered",
      minWidth: 140,
    },

    {
      field: "CallsAbandoned",
      flex: 1,
      headerName: "Abandoned",
    },

    {
      field: "GhostCalls",
      flex: 1,
      headerName: "Ghost Call",
    },
  ];

  // const dummyIVR = [
  //   {
  //     id: 1,
  //     phoneNo: "081234567890",
  //     callTime: "20230202T223252+0700",
  //     status: "Active",
  //     menu: "Pembayaran",
  //     duration: 731000,
  //     name: "IVR Satu",
  //   },

  //   {
  //     id: 2,
  //     phoneNo: "081234567890",
  //     callTime: "20230202T223252+0700",
  //     status: "Hang up",
  //     menu: "Toilet",
  //     duration: 731000,
  //     name: "IVR Satu",
  //   },

  //   {
  //     id: 3,
  //     phoneNo: "081234567890",
  //     callTime: "20230202T223252+0700",
  //     status: "Transfer to ACD",
  //     menu: "Greetings",
  //     duration: 731000,
  //     name: "IVR Satu",
  //   },

  //   {
  //     id: 4,
  //     phoneNo: "081234567890",
  //     callTime: "20230202T223252+0700",
  //     status: "Hang Up",
  //     menu: "Greetings",
  //     duration: 731000,
  //     name: "IVR Satu",
  //   },
  // ];

  // const dummyCallsWaiting = [
  //   {
  //     id: 1,
  //     phoneNo: "081234567890",
  //     duration: 10000,
  //     agent: "cole",
  //   },

  //   {
  //     id: 2,
  //     phoneNo: "081234567890",
  //     duration: 10000,
  //     agent: "kdot",
  //   },

  //   {
  //     id: 3,
  //     phoneNo: "081234567890",
  //     duration: 10000,
  //     agent: "drizzy",
  //   },

  //   {
  //     id: 4,
  //     phoneNo: "081234567890",
  //     duration: 10000,
  //     agent: "21",
  //   },
  // ];

  const optionsACDAgents = {
    responsive: true,

    plugins: {
      datalabels: {
        font: {
          size: 16,
          weight: 700,
        },

        color: (context) => {
          return context.dataset.backgroundColor[context.dataIndex] ===
            "#00FF00" ||
            context.dataset.backgroundColor[context.dataIndex] === "#FFE900"
            ? "#393939"
            : "#FFF";
        },

        display: (context) => context.dataset.data[context.dataIndex] > 0,

        formatter: (value) => {
          const filteredAgents = data.acdagentDetail
            ? data.acdagentDetail.filter(
                (agent) => agent.CurrentState !== "LOGGEDOFF"
              )
            : [];

          const countPercentage = (value, total) =>
            Math.round((100 * value) / total);
          return countPercentage(value, filteredAgents.length) + "%";
        },
      },

      legend: {
        display: false,
      },
    },
  };

  const optionsHourly = {
    maintainAspectRatio: false,
    responsive: true,

    plugins: {
      legend: { position: "top" },

      title: {
        color: "#000",
        display: true,

        font: {
          size: 18,
          weight: 500,
        },

        text: `Hourly - ${moment().format("D MMM YYYY")}`,
      },
    },
  };

  const labels = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24,
  ];

  const dataHourly = {
    labels,

    datasets: [
      {
        label: "Calls Offered",
        data: labels.map((label) => {
          let hourlyData = data?.acdhourly?.find((data) => data.Time === label);
          return hourlyData ? hourlyData.TotalCallsOffered : 0;
        }),
        backgroundColor: "#C886D3",
      },

      {
        label: "Abandoned",
        data: labels.map((label) => {
          let hourlyData = data?.acdhourly?.find((data) => data.Time === label);
          return hourlyData ? hourlyData.TotalCallsAbandoned : 0;
        }),
        backgroundColor: "#FF9800",
      },

      {
        label: "Connected",
        data: labels.map((label) => {
          let hourlyData = data?.acdhourly?.find((data) => data.Time === label);
          return hourlyData ? hourlyData.TotalCallsAnswered : 0;
        }),
        backgroundColor: "#4CAF50",
      },
    ],
  };

  const dataACDAgents = {
    labels: ["Ready", "Busy", "ACW", "AUX", "Not Bound"],

    datasets: [
      {
        data: Object.values(statusCount),

        backgroundColor: [
          "#00FF00",
          "#FF0000",
          "#FFE900",
          "#EE7314",
          "#727272",
        ],
      },
    ],
  };

  return (
    <div className="acd-monitoring">
      <section className="cards">
        <div className="item calls-offered">
          <Icon
            className="icon"
            height="40"
            icon="ic:baseline-add-ic-call"
            width="40"
          />

          <div>
            <p className="title">Calls Offered</p>

            <p className="value">
              {data.acdsummary?.length ? data.acdsummary[0].CallsOffered : 0}
            </p>

            <p className="title">Ghost Calls</p>

            <p className="value">
              {data.acdsummary?.length ? data.acdsummary[0].GhostCalls : 0}
            </p>
          </div>
        </div>

        <div className="item calls-abandoned">
          <Icon
            className="icon"
            height="40"
            icon="material-symbols:phone-missed"
            width="40"
          />

          <div>
            <p className="title">Calls Abandoned</p>

            <p className="value">
              {data.acdsummary?.length ? data.acdsummary[0].CallsAbandoned : 0}
            </p>

            <p className="title">Abandon Rate</p>

            <p className="value">
              {data.acdsummary?.length ? data.acdsummary[0].AbandonRate : 0}%
            </p>
          </div>
        </div>

        <div className="item calls-connected">
          <Icon
            className="icon"
            height="40"
            icon="material-symbols:phone-callback-rounded"
            width="40"
          />

          <div>
            <p className="title">Calls Answered</p>

            <p className="value">
              {data.acdsummary?.length ? data.acdsummary[0].CallsAnswered : 0}
            </p>

            <p className="title">Answer Rate</p>

            <p className="value">
              {data.acdsummary?.length ? data.acdsummary[0].AnswerRate : 0}%
            </p>

            <p className="title">Avg Speed Answer</p>

            <p className="value">
              {data.acdsummary?.length ? data.acdsummary[0].SpeedOfAnswer : 0}s
            </p>
          </div>
        </div>

        <div className="item service-level">
          <Icon
            className="icon"
            height="40"
            icon="material-symbols:humidity-percentage-rounded"
            width="40"
          />

          <div>
            <p className="title">Service Level</p>
            <p className="value">{data.sla?.length ? data.sla[0].SLA : 0}%</p>
            <p className="title">Avg Call Duration</p>

            <p className="value">
              {formatSecondsToDuration(
                data.acdsummary?.length ? data.acdsummary[0].AvgCallDuration : 0
              )}
            </p>
          </div>
        </div>
      </section>

      <section className="calls">
        <div
          className={`item ivr-detail ${showIVRDetail ? "expanded" : ""}`}
          onClick={() => setshowIVRDetail(!showIVRDetail)}
        >
          <header>
            <div className="title">
              <IVRMonitoringIcon fill="#0343C7" height="26" width="26" />

              <p>IVR Detail</p>
            </div>

            <p className="amount">{data.ivrdetail?.length}</p>
          </header>

          <div style={{ maxHeight: 200, height: 200 }}>
            <DataGrid
              className="table"
              columns={columnsIVR}
              disableColumnFilter
              disableColumnMenu
              disableColumnSelector
              disableSelectionOnClick
              hideFooter
              loading={isLoading}
              rows={data.ivrdetail ? data.ivrdetail : []}
              getRowId={(row) => row.CallTime + row.CallerNo}
            />
          </div>
        </div>
        <div
          className={`item calls-waiting ${showCallsWaiting ? "expanded" : ""}`}
          onClick={() => setshowCallsWaiting(!showCallsWaiting)}
        >
          <header>
            <div className="title">
              <Icon
                height="26"
                icon="material-symbols:timer-rounded"
                width="26"
              />

              <p>Calls Waiting</p>
            </div>

            <p className="amount">{data.callswaiting?.length}</p>
          </header>
          <div style={{ maxHeight: 200, height: 200 }}>
            <DataGrid
              className="table"
              columns={columnsCallsWaiting}
              disableColumnFilter
              disableColumnMenu
              disableSelectionOnClick
              hideFooter
              rows={data.callswaiting ? data.callswaiting : []}
              getRowId={(row) => row.ID}
            />
          </div>
        </div>
      </section>

      <section className="agents-detail">
        <div className="agents-chart">
          <div style={{ height: 300 }}>
            <Doughnut
              data={dataACDAgents}
              options={optionsACDAgents}
              plugins={[ChartDataLabels]}
            />
          </div>
          <div className="agents-chart-legend">
            <div className="ready">
              <Icon height="26" icon="tabler:square-rounded-check" width="26" />

              <span>Ready</span>
              <span className="count">{statusCount.ready}</span>
            </div>

            <div className="busy">
              <Icon
                height="26"
                icon="tabler:alert-square-rounded-filled"
                width="26"
              />

              <span>Busy</span>
              <span className="count">{statusCount.busy}</span>
            </div>

            <div className="acw">
              <LegendACW />
              <span>ACW</span>
              <span className="count">{statusCount.acw}</span>
            </div>

            <div className="aux">
              <LegendAUX />
              <span>AUX</span>
              <span className="count">{statusCount.aux}</span>
            </div>

            <div className="not-bound">
              <Icon height="26" icon="tabler:square-rounded-x" width="26" />

              <span>Not Bound</span>
              <span className="count">{statusCount.notBound}</span>
            </div>
          </div>
        </div>

        <div className="item acd-agents">
          <header>
            <div className="title">
              <Icon height="26" icon="ic:round-support-agent" width="26" />

              <p>ACD Agents Detail</p>

              <div className="select-container">
                <p>Status</p>

                <Select
                  className="select-status"
                  sx={{
                    boxShadow: "none",
                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                      { border: 0 },
                    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      { border: 0 },
                  }}
                  value={1}
                >
                  <MenuItem value={1}>All</MenuItem>
                </Select>
              </div>
            </div>

            <p className="amount">
              {
                data.acdagentDetail?.filter(
                  (agent) => agent.CurrentState !== "LOGGEDOFF"
                ).length
              }
            </p>
          </header>
          <div style={{ height: 360 }}>
            <DataGrid
              className="table"
              columns={columnsACDAgents}
              disableColumnFilter
              disableColumnMenu
              disableSelectionOnClick
              hideFooter
              rows={
                data.acdagentDetail
                  ? data.acdagentDetail.filter(
                      (agent) => agent.CurrentState !== "LOGGEDOFF"
                    )
                  : []
              }
              getRowId={(row) => row.AgentName + "-" + row.Ext}
            />
          </div>
        </div>
      </section>

      <section className="graph">
        <div className="item hourly-chart">
          <Bar className="table" options={optionsHourly} data={dataHourly} />
        </div>
      </section>
    </div>
  );
};

export default ACDMonitoring;
